/* eslint-disable @typescript-eslint/no-unsafe-return */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TranslateReplaceService implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.http.get(`./assets/i18n/${lang}.json`).pipe(
      map((response: JSON) => {
        if (!document.location.hostname.includes('pro')) {
          return response;
        }

        const obj = JSON.stringify(response).replace(/Inyova Invest/g, 'Inyova Pro');
        return JSON.parse(obj);
      })
    );
  }
}
